import React from 'react';
import { Popover, Box } from '@mui/material';
import { ColorPalette } from '../../config/ColorPicker';

const ColorPaletteUI = ({ onClick, anchorEl, handlePopoverClose }) => {
  return (
    <Popover
      id={Boolean(anchorEl) ? 'color-popover' : undefined}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handlePopoverClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          sx: {
            width: 360,
            px: 0.5,
            py: 1,
          },
        },
      }}
    >
      <Box display="flex" flexWrap="wrap" gap="0.3rem" justifyContent="center">
        {ColorPalette.filter((item) => item !== '#FFFFFF').map((item) => (
          <Box
            height={25}
            width={25}
            borderRadius="50%"
            border="2px solid lightgrey"
            sx={{
              cursor: 'pointer',
            }}
            onClick={() => onClick(item)}
            backgroundColor={item}
          />
        ))}
      </Box>
    </Popover>
  );
};

export default ColorPaletteUI;
